module.exports = __webpack_public_path__ + "img/technoPlus.41a41cdc.png";